import React from 'react';
import { IconButton, useMediaQuery } from '@mui/material';
import { 
  PlaylistAdd, 
  Favorite, 
  FavoriteBorder, 
  Bookmark, 
  BookmarkBorder,
  Edit,
  Delete
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';

const RecipeActions = ({
  recipe,
  favorites,
  bookmarks,
  toggleFavorite,
  toggleBookmark,
  onOpenMenuDialog,
  onOpenDeleteDialog,
  userRecipe
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  
  if (!recipe) return null;
  
  return (
    <>
      <IconButton
        onClick={onOpenMenuDialog}
        color="primary"
        size={isMobile ? "medium" : "small"}
      >
        <PlaylistAdd />
      </IconButton>
      <IconButton
        onClick={() => toggleFavorite(recipe.id)}
        color={favorites.has(recipe.id) ? "error" : "default"}
        size={isMobile ? "medium" : "small"}
      >
        {favorites.has(recipe.id) ? <Favorite /> : <FavoriteBorder />}
      </IconButton>
      <IconButton
        onClick={() => toggleBookmark(recipe.id)}
        color={bookmarks.has(recipe.id) ? "primary" : "default"}
        size={isMobile ? "medium" : "small"}
      >
        {bookmarks.has(recipe.id) ? <Bookmark /> : <BookmarkBorder />}
      </IconButton>
      {userRecipe && (
        <>
          <IconButton
            onClick={() => navigate(`/recipe/${recipe.id}/edit`)}
            color="default"
            size={isMobile ? "medium" : "small"}
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={onOpenDeleteDialog}
            color="default"
            size={isMobile ? "medium" : "small"}
          >
            <Delete />
          </IconButton>
        </>
      )}
    </>
  );
};

export default RecipeActions; 